

























/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
import { EventBus } from "../event-bus";
import { Token } from "../utils/Token";

@Component({
  components: {},
})
export default class Log extends Vue {
  @Prop() user!: any;

  private log: any[] = [];
  private logSocket: any;

  created() {
    const id = this.user.accountId;
    // log socket connection start //
   
    this.fetchLog(this.user.accountId);
   
    EventBus.$off('refreshAccountLogs')
    EventBus.$off('LogSocketClose')
    //when accountLogs socket receives message, emits to this event to refresh log table
    EventBus.$on("refreshAccountLogs", (value: Array<any>) => {
      this.log = value;
    });

    EventBus.$on("LogSocketClose", (value: Array<any>) => {
      this.logSocket.closeSocket();
    });
  }


  
  private async fetchLog(id: number) {
    this.log = []; // clear prior log table
    const token = await Token.getTokenWithExpiry("token");
    ////EventBus.$emit("BeginLoader",null );   

    axios({
      method: "get",
      withCredentials: true,
      url: `${process.env.VUE_APP_BASE_URL}/account/${id}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        ////EventBus.$emit("FinishLoader",null );   

        console.log("response of get account:", response);
        response.data.results.forEach((result: any) => {
          this.log.push(result);
        });
        console.log("this.log:", this.log);
      })
      .catch((err) => {
        ////EventBus.$emit("FinishLoader",null );   

        console.log("error:", err);
      });
  }

  private headers = [
    {
      text: "In / Out",
      align: "start",
      value: "inOut",
      sortable: true,
    },
    {
      text: "From / To",
      value: "fromTo",
      sortable: true,
      align: "start",
    },
    {
      text: "Date & Time",
      value: "dateTime",
      sortable: true,
      align: "center",
    },
    {
      text: "Duration",
      value: "duration",
      sortable: true,
      align: "center",
    },
  ];
}
